/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_buf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500 mL of 1X TBS needs 1.21 g Tris base and 4 g NaCl.`)
};

const es_buf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500 mL de TBS 1X necesitan 1.21 g de Tris base y 4 g de NaCl.`)
};

const de_buf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500 mL 1X TBS benötigen 1,21 g Tris-Base und 4 g NaCl.`)
};

const nl_buf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500 mL 1X TBS vereist 1,21 g Tris-base en 4 g NaCl.`)
};

const fr_buf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500 mL de TBS 1X nécessitent 1,21 g de base Tris et 4 g de NaCl.`)
};

const it_buf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500 mL di TBS 1X richiedono 1,21 g di Tris base e 4 g di NaCl.`)
};

const pt_br2_buf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500 mL de TBS 1X precisam de 1,21 g de Tris base e 4 g de NaCl.`)
};

const pt_buf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`500 mL de TBS 1X precisam de 1,21 g de Tris base e 4 g de NaCl.`)
};

const ja_buf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1X TBS 500 mLには、Tris塩基1.21gとNaCl 4gが必要です。`)
};

const zh_buf_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配制 500 mL 1X TBS 需要 1.21 g Tris 碱和 4 g NaCl。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const buf_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.buf_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("buf_ex1", locale)
	if (locale === "en") return en_buf_ex1(inputs)
	if (locale === "es") return es_buf_ex1(inputs)
	if (locale === "de") return de_buf_ex1(inputs)
	if (locale === "nl") return nl_buf_ex1(inputs)
	if (locale === "fr") return fr_buf_ex1(inputs)
	if (locale === "it") return it_buf_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_buf_ex1(inputs)
	if (locale === "pt") return pt_buf_ex1(inputs)
	if (locale === "ja") return ja_buf_ex1(inputs)
	return zh_buf_ex1(inputs)
};